import { render, staticRenderFns } from "./edit_closure.vue?vue&type=template&id=1a30c41c"
import script from "./edit_closure.vue?vue&type=script&lang=js"
export * from "./edit_closure.vue?vue&type=script&lang=js"
import style0 from "./edit_closure.vue?vue&type=style&index=0&id=1a30c41c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports